import { SmsNotificationsModal } from './SmsNotificationsModal';

const source = 'ad-hoc';

export const SmsNotificationsPrompt = (props: { onClose: () => void }) => (
  <SmsNotificationsModal source={source} isAdhoc={true} onClose={props.onClose} />
);
